import { Component } from 'react';
import { connect } from "react-redux";

import PageBanner from "../common/page/PageBanner.js";
import EmailAddressSelectionList from '../common/selection/EmailAddressSelectionList.js';
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList.js';
import AlertHistoryViewRow from './AlertHistoryViewRow.js';
import { listIcon } from "../../img/font_awesome/font_awesome.js"
import { Button, Container, Modal } from 'react-bootstrap'
import axios from "axios";
import configData from "../../config/config.json";
import translations from "../../config/translation/home_translations.json"

import { LOADING_STATUES } from "../constants/constants.js";
import Loading from '../common/modal/Loading.js';

const mapStateToProps = state => {
  return {
    currentUser: state.currentUserReducer,
    language: state.languageReducer ? state.languageReducer : 'ENGLISH'
  };
}

class AlertHistoryView extends Component {

  state = {
    filteredList: [],
    filterText: '',
    emailAddressId: '',
    emailAddressName: '',
    phoneNumberId: '',
    phoneNumberName: '',
		showEmailAddressList: false,
		showPhoneNumberList: false,
    loadingStatus: ""
  }

  showLoading = () => {
    if (this.state.loadingStatus === "") {
      this.setState({
        loadingStatus: LOADING_STATUES.LOADING
      })
      return true;
    }
    return false;
  }

  handleOpenAlertEntryCallBack = (message) => {
    this.setState({
      loadingStatus: "",
      submitMessage: ""
    });

    this.props.handleOpenAlertEntry();
  }
  
  hideLoading = (message, status) => {
    if (status === 'ERROR') {
      this.setState({
        loadingStatus: "",
        submitMessage: ""
      })
    } else {
      this.setState({
        loadingStatus: "",
        submitMessage: message
      })
    }
  }

  handleFilter = () => {
    if (this.showLoading() !== true) {
      return;
    }

    let filters = { filterText: this.state.filterText, emailAddressId: this.state.emailAddressId, phoneNumberId: this.state.phoneNumberId };
    axios.post(configData.LANDNOTIFICATION_SERVER_URL + "home/alertHistory", filters, { withCredentials: true })
      .then((response) => {
        this.setState({ filteredList: response.data.content.outgoingEvents, loadingStatus: '' })
      }, (error) => {
        // handleError(error, this.props.history);
      });
  }

  handleCloseClick = (event) => {
    if (event) {
       event.preventDefault();
    }
    this.setState({  errors: {} })
    this.props.handleClose();
 }

 handleCloseEmailAddressLookup = (selectedId, selectedName) => {
  this.setState({
    phoneNumberId: 0,
    showEmailAddressList: false,
    emailAddressId: selectedId,
    emailAddressName: selectedName
  },  function() { this.handleFilter() } );
}

handleEmailAddressFinderFilterClick = () => {
  this.setState( {
    showEmailAddressList : true
    });
}

handleEmailAddressFinderFilterReset = () => {
  this.setState({ emailAddressId: 0 },  function() { this.handleFilter() } )
}

handleClosePhoneNumberLookup = (selectedId, selectedName) => {
  this.setState({
    emailAddressId: 0,
    showPhoneNumberList: false,
    phoneNumberId: selectedId,
    phoneNumberName: selectedName
  },  function() { this.handleFilter() } );
}

handlePhoneNumberFinderFilterClick = () => {
  this.setState( {
    showPhoneNumberList : true
    });
}

handlePhoneNumberFinderFilterReset = () => {
  this.setState({ phoneNumberId: 0 },  function() { this.handleFilter() } )
}

  handleTextFilter = (filterText) => {
    this.setState({ filterText: filterText },  function() { this.handleFilter() } )
  }
  
  handleTextFilterReset = () => {
		this.setState({ filterText: '' }, function () { this.handleFilter() })
	}

  openNewAlertEntry = (event) => {
    event.preventDefault();
    this.props.handleNewAlertEntry();
  }

  componentDidMount() {
    this.handleFilter();
  }

  render() {

    const emailAddressFinderFilterProps = {
      finderFilterClick: this.handleEmailAddressFinderFilterClick,
      finderFilterReset: this.handleEmailAddressFinderFilterReset,
      name: this.state.emailAddressName,
      id: this.state.emailAddressId
    }

		const phoneNumberFinderFilterProps = {
			finderFilterClick: this.handlePhoneNumberFinderFilterClick,
			finderFilterReset: this.handlePhoneNumberFinderFilterReset,
			name: this.state.phoneNumberName,
			id: this.state.phoneNumberId
		}

    return (
      <>
        <Modal show={this.props.show} onHide={this.handleCloseClick} size="lg" centered>
          <Modal.Header style={{ background: '#145A7B', color: 'white' }}>
            <Modal.Title>{listIcon}&nbsp;&nbsp;{translations[this.props.language].alert_history}</Modal.Title>
            <span style={{ textAlign: 'right' }}><Button variant="link" id='alertHistoryClose' style={{textDecoration: 'none'}} onClick={this.handleCloseClick} aria-label='Close'>&#x2716;</Button></span>
          </Modal.Header>
          <Modal.Body>
            <Container style={{ marginTop: 0, marginBottom: 10, paddingTop: 0, paddingBottom: 10 }}>
              <PageBanner pageHeading='' finderFilterProps={emailAddressFinderFilterProps} finderFilterProps2={phoneNumberFinderFilterProps} buttons={[]} />
              {
                this.state.filteredList.map((alertResult, index) => {
                  return (
                    <AlertHistoryViewRow key={index} id={alertResult.id} alertResult={alertResult} ></AlertHistoryViewRow>
                  )
                })
              }
            </Container>
          </Modal.Body>
        </Modal>
        <Loading loadingIndicator={this.state.loadingStatus === LOADING_STATUES.LOADING} />
        <EmailAddressSelectionList userId={this.props.currentUser.userId} showModal={this.state.showEmailAddressList}  onHide={(selectedId, selectedName) => this.handleCloseEmailAddressLookup(selectedId, selectedName)} />
        <PhoneNumberSelectionList userId={this.props.currentUser.userId}  showModal={this.state.showPhoneNumberList}  onHide={(selectedId, selectedName) => this.handleClosePhoneNumberLookup(selectedId, selectedName)} />
      </>
    )
  }
}

export default connect(mapStateToProps)(AlertHistoryView);